var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoasset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    viewBox: "0 0 750 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-no-data:not(.animated) .animable {opacity: 0;}svg#freepik_stories-no-data.animated #freepik--Lamp--inject-45 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-no-data.animated #freepik--Floor--inject-45 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-no-data.animated #freepik--Plant--inject-45 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-no-data.animated #freepik--Character--inject-45 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-no-data.animated #freepik--Folder--inject-45 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-no-data.animated #freepik--speech-bubble--inject-45 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}            @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }")), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    fill: "#407bff",
    style: {
      transformOrigin: "395.46px 48.595px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M335.23,97.19H455.69S444.57,44,394.55,44C350.06,44,335.23,97.19,335.23,97.19Z",
    style: {
      transformOrigin: "395.46px 70.595px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 394.17,
    width: 2.58,
    height: 43.98,
    style: {
      transformOrigin: "395.46px 21.99px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "375px 439.83px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M663.67,439.83c0,.14-129.25.26-288.66.26S86.33,440,86.33,439.83s129.23-.26,288.68-.26S663.67,439.68,663.67,439.83Z",
    fill: "#263238",
    style: {
      transformOrigin: "375px 439.83px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "131.448px 408.86px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M118.29,377.2a12.62,12.62,0,0,1,8.78,4.5,22.15,22.15,0,0,1,4.47,9c1.69,6.32.65,13.79-1.15,20.08-6.84-2.45-11.07-9.75-13-13.59-3-6.06-4.79-18.86.87-20",
    fill: "#407bff",
    style: {
      transformOrigin: "123.482px 393.985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M140.24,418.45a10.74,10.74,0,0,1-.5-10.78,14.26,14.26,0,0,1,8.6-6.91c1.67-.52,3.61-.73,5.06.24a4.58,4.58,0,0,1,1.77,4.31,9.27,9.27,0,0,1-2,4.42c-3.33,4.51-7.37,8.26-13,8.72",
    fill: "#407bff",
    style: {
      transformOrigin: "146.872px 409.386px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M141,439.58a6.5,6.5,0,0,1-.31-1.31c-.18-.94-.42-2.15-.71-3.6a37.77,37.77,0,0,1-.74-12.11,23,23,0,0,1,4.49-11.21,15.32,15.32,0,0,1,2.59-2.63,9.16,9.16,0,0,1,.82-.58,1.15,1.15,0,0,1,.3-.18,25.37,25.37,0,0,0-3.45,3.59,23.85,23.85,0,0,0-4.28,11.08c-.64,4.66.15,8.93.61,12,.24,1.53.44,2.77.55,3.63A8.23,8.23,0,0,1,141,439.58Z",
    fill: "#263238",
    style: {
      transformOrigin: "143.245px 423.77px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M120.49,386.83a2.34,2.34,0,0,1,.28.51c.18.4.42.9.7,1.53.61,1.33,1.46,3.26,2.49,5.65,2.06,4.79,4.82,11.45,7.7,18.87s5.33,14.19,7,19.12c.86,2.46,1.53,4.46,2,5.85.21.66.37,1.19.5,1.6a2.61,2.61,0,0,1,.15.57,2.46,2.46,0,0,1-.24-.54c-.15-.4-.34-.92-.59-1.57l-2.11-5.8c-1.79-4.89-4.29-11.65-7.16-19.06s-5.59-14.09-7.57-18.91c-1-2.37-1.77-4.3-2.34-5.71-.26-.64-.47-1.15-.63-1.56A3.49,3.49,0,0,1,120.49,386.83Z",
    fill: "#263238",
    style: {
      transformOrigin: "130.9px 413.68px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M132.87,425.6a25.18,25.18,0,0,0-19.52-12.13c-2-.14-4.46.2-5.36,2s.3,4,1.68,5.46a21.49,21.49,0,0,0,23.27,5.2",
    fill: "#407bff",
    style: {
      transformOrigin: "120.309px 420.506px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M116.43,418.89a7.15,7.15,0,0,1,1.27.05,12.09,12.09,0,0,1,1.47.17c.57.11,1.24.17,1.94.37a19.41,19.41,0,0,1,2.31.64,22.91,22.91,0,0,1,2.57,1,27.8,27.8,0,0,1,5.42,3.21,27.31,27.31,0,0,1,4.48,4.44,22.49,22.49,0,0,1,1.57,2.25,21.93,21.93,0,0,1,1.18,2.09,17.4,17.4,0,0,1,.8,1.8,11.34,11.34,0,0,1,.51,1.4,6.82,6.82,0,0,1,.33,1.23c-.11,0-.59-1.72-1.94-4.28a22,22,0,0,0-1.21-2,25.32,25.32,0,0,0-1.58-2.19,26.65,26.65,0,0,0-9.74-7.52c-.87-.38-1.7-.74-2.51-1a21.87,21.87,0,0,0-2.27-.69C118.23,419.09,116.42,419,116.43,418.89Z",
    fill: "#263238",
    style: {
      transformOrigin: "128.355px 428.211px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "564.68px 255.511px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M570.36,105.48c-2.94.67-4.37,4.06-4.65,7.06s.1,6.18-1.16,8.92c-1.42,3.08-4.81,5.36-4.92,8.75-.07,2.07,1.16,4,1.1,6.09-.1,3.4-3.56,6-3.75,9.36-.13,2.45,1.5,4.79,1.11,7.21-.3,1.88-1.77,3.36-2.39,5.16-1.23,3.6,1.24,7.55,4.45,9.57a14.59,14.59,0,0,0,21.25-6.78c1.78-4.32,1.39-9.19,1-13.84q-1.8-21.76-2.68-43.58",
    fill: "#263238",
    style: {
      transformOrigin: "569.054px 136.619px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M561.82,156.66a3.41,3.41,0,0,0,1.35-1.59,5.79,5.79,0,0,0,.34-2.45,13.47,13.47,0,0,0-.73-3.23,9.31,9.31,0,0,1-.52-4.1c.25-1.56,1.37-2.84,2.38-4.1a8.77,8.77,0,0,0,1.35-2.05,3.31,3.31,0,0,0,.16-2.4c-.52-1.63-2.12-2.83-2.85-4.72a5,5,0,0,1-.16-2.92,11.59,11.59,0,0,1,1-2.61,22.41,22.41,0,0,0,2-4.71c.7-3.17.37-6.2.85-8.69a9.62,9.62,0,0,1,2.53-5.32,5.81,5.81,0,0,1,1.32-1,2.07,2.07,0,0,1,.53-.19,7.69,7.69,0,0,0-1.71,1.28,9.78,9.78,0,0,0-2.31,5.25,32.58,32.58,0,0,0-.28,4,24.63,24.63,0,0,1-.46,4.69,22.46,22.46,0,0,1-2,4.82c-.75,1.57-1.44,3.41-.78,5.13s2.25,2.91,2.86,4.75a3.88,3.88,0,0,1-.19,2.75A9.46,9.46,0,0,1,565,141.5c-1,1.26-2.09,2.46-2.33,3.86a9,9,0,0,0,.46,3.93,13.62,13.62,0,0,1,.66,3.32,5.61,5.61,0,0,1-.45,2.54,3.06,3.06,0,0,1-1,1.26A1.58,1.58,0,0,1,561.82,156.66Z",
    fill: "#455a64",
    style: {
      transformOrigin: "566.595px 131.62px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m554 180.37-9 26-37.64 2-6.28 14 39.3 4a14.85 14.85 0 0 0 19.62-8.73l10.49-29.28z",
    fill: "#b78876",
    style: {
      transformOrigin: "535.785px 203.926px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M631.81,425.7s-27.58-87.62-28.17-90.46c-.53-2.58,10-65.63,11.34-82l-37.27,1.39V255l-15.84.88L576.05,435H593.2l-1.7-59.45c10.58,28.39,25.74,57.33,25.74,57.33Z",
    fill: "#b78876",
    style: {
      transformOrigin: "596.84px 344.12px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m592.2 396.88c0-0.54-0.21-19.92-0.21-19.92-0.21 1.16-6.57-16.82-6.42-17.91 0.08-0.57 6.63 37.83 6.63 37.83z",
    fill: "#a36957",
    style: {
      transformOrigin: "588.884px 377.962px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M584.85,350.53a3.88,3.88,0,0,0-.11,1.09,27.15,27.15,0,0,0,0,3c0,.63.09,1.31.17,2.05s.19,1.52.36,2.33a41.36,41.36,0,0,0,1.41,5.22c1.24,3.63,2.62,6.8,3.59,9.1.46,1,.86,1.95,1.2,2.71a4.32,4.32,0,0,0,.5,1,3.79,3.79,0,0,0-.3-1c-.23-.66-.58-1.61-1-2.78-.88-2.34-2.2-5.54-3.43-9.13a43.34,43.34,0,0,1-1.43-5.14c-.18-.8-.3-1.57-.41-2.29s-.19-1.4-.24-2c-.12-1.24-.17-2.24-.2-2.94A4.52,4.52,0,0,0,584.85,350.53Z",
    fill: "#a36957",
    style: {
      transformOrigin: "588.334px 363.78px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m575.73 435.91v-1.61l17.57-0.77 0.05 6.65-1.08 0.07c-4.83 0.28-24.55 1.1-27.77 0.13-3.61-1.08 11.23-4.47 11.23-4.47z",
    fill: "#455a64",
    style: {
      transformOrigin: "578.642px 437.185px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M593.58,439.78a2.29,2.29,0,0,1-.3,0l-.86.06-3.18.14c-2.68.11-6.39.21-10.48.23s-7.81-.05-10.5-.13l-3.17-.13-.87,0-.3,0a1.85,1.85,0,0,1,.3,0h.87l3.18.06c2.68,0,6.39.08,10.48.06s7.81-.09,10.49-.16l3.18-.08h1.16Z",
    fill: "#263238",
    style: {
      transformOrigin: "578.75px 439.997px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m570 440.34a7.67 7.67 0 0 0-0.6-1.51 7.21 7.21 0 0 0-1.09-1.21 2.32 2.32 0 0 1 1.27 1.1 2.39 2.39 0 0 1 0.42 1.62z",
    fill: "#263238",
    style: {
      transformOrigin: "569.161px 438.98px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M575.18,437.71s-.29-.27-.55-.67-.42-.75-.37-.78.29.26.55.66S575.23,437.68,575.18,437.71Z",
    fill: "#263238",
    style: {
      transformOrigin: "574.72px 436.984px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M576.6,437c0,.05-.32-.14-.62-.41s-.52-.52-.48-.56.32.14.62.41S576.64,436.91,576.6,437Z",
    fill: "#263238",
    style: {
      transformOrigin: "576.05px 436.516px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M577.49,435.3a2.11,2.11,0,0,1-.92.12,2,2,0,0,1-.91-.09,2.08,2.08,0,0,1,.91-.12A2,2,0,0,1,577.49,435.3Z",
    fill: "#263238",
    style: {
      transformOrigin: "576.575px 435.314px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m577.79 434.14a1.86 1.86 0 0 1-1 0.3 1.89 1.89 0 0 1-1-0.14 5.77 5.77 0 0 1 1-0.08 5.19 5.19 0 0 1 1-0.08z",
    fill: "#263238",
    style: {
      transformOrigin: "576.79px 434.298px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M574.59,436.18a3.07,3.07,0,0,1-1.13,0,6.46,6.46,0,0,1-1.19-.26,3.23,3.23,0,0,1-.69-.28.63.63,0,0,1-.28-.35.44.44,0,0,1,.17-.45,2.08,2.08,0,0,1,2.92,1.35.76.76,0,0,1,0,.3,3.22,3.22,0,0,0-.52-1,2.06,2.06,0,0,0-1-.62,1.78,1.78,0,0,0-1.34.1c-.17.13-.1.34.09.46a3.61,3.61,0,0,0,.64.27,8.41,8.41,0,0,0,1.15.29C574.16,436.15,574.59,436.15,574.59,436.18Z",
    fill: "#263238",
    style: {
      transformOrigin: "572.94px 435.561px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M574.3,436.24a1.06,1.06,0,0,1-.14-.78,1.86,1.86,0,0,1,.31-.82,1.14,1.14,0,0,1,.93-.58.46.46,0,0,1,.35.52,1.19,1.19,0,0,1-.19.5,4.13,4.13,0,0,1-.53.69,1.64,1.64,0,0,1-.64.45s.22-.2.53-.56a3.88,3.88,0,0,0,.47-.67c.15-.24.26-.67,0-.72s-.56.26-.73.48a1.83,1.83,0,0,0-.32.73A3.52,3.52,0,0,0,574.3,436.24Z",
    fill: "#263238",
    style: {
      transformOrigin: "574.947px 435.15px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M593.21,435s-.5,0-1.29.05a5.54,5.54,0,0,0-4.57,3.67c-.26.75-.28,1.26-.32,1.25s0-.13,0-.35a4.48,4.48,0,0,1,.18-.95,5.47,5.47,0,0,1,1.76-2.61,5.39,5.39,0,0,1,2.93-1.15,4.19,4.19,0,0,1,1,0A1.26,1.26,0,0,1,593.21,435Z",
    fill: "#263238",
    style: {
      transformOrigin: "590.111px 437.425px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m584.8 438.38a9.81 9.81 0 0 1-2.56 0.25 9.43 9.43 0 0 1-2.55-0.22c0-0.06 1.14 0 2.55 0s2.55-0.09 2.56-0.03z",
    fill: "#263238",
    style: {
      transformOrigin: "582.245px 438.501px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M588.22,438.35s-.09.24-.21.5-.18.5-.24.49-.09-.27.05-.58S588.18,438.3,588.22,438.35Z",
    fill: "#263238",
    style: {
      transformOrigin: "587.97px 438.84px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M589.51,436.74s-.07.22-.25.4-.36.3-.41.26.07-.22.25-.41S589.46,436.69,589.51,436.74Z",
    fill: "#263238",
    style: {
      transformOrigin: "589.174px 437.068px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M591.35,436c0,.06-.24.06-.5.15s-.44.23-.49.19.1-.28.42-.39S591.37,435.94,591.35,436Z",
    fill: "#263238",
    style: {
      transformOrigin: "590.851px 436.124px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M592.66,435.64c0,.06-.07.15-.22.2s-.28.06-.3,0,.08-.15.22-.2S592.64,435.59,592.66,435.64Z",
    fill: "#263238",
    style: {
      transformOrigin: "592.399px 435.742px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m616.89 434.36-0.66-1.47 15.71-7.89 2.77 6-1 0.51c-4.29 2.23-21.94 11.05-25.28 11.49-3.69 0.53 8.46-8.64 8.46-8.64z",
    fill: "#455a64",
    style: {
      transformOrigin: "621.221px 434.011px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M634.77,430.57l-.26.16-.77.4-2.84,1.44c-2.4,1.19-5.74,2.8-9.47,4.5s-7.15,3.15-9.63,4.18l-2.95,1.19-.8.31a1.14,1.14,0,0,1-.29.09l.27-.13.79-.35,2.92-1.25c2.47-1.06,5.87-2.54,9.6-4.24s7.08-3.28,9.5-4.44l2.86-1.37.79-.37Z",
    fill: "#263238",
    style: {
      transformOrigin: "621.265px 436.705px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M613.52,440.74a7.38,7.38,0,0,0-1.17-1.14,6.94,6.94,0,0,0-1.49-.66,2.81,2.81,0,0,1,2.66,1.8Z",
    fill: "#263238",
    style: {
      transformOrigin: "612.19px 439.84px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M617.13,436.22s-.38-.12-.78-.38-.69-.51-.66-.56.38.12.78.38S617.16,436.17,617.13,436.22Z",
    fill: "#263238",
    style: {
      transformOrigin: "616.41px 435.746px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M618.11,435c0,.05-.34,0-.73-.12s-.68-.27-.67-.33a1.49,1.49,0,0,1,.74.12C617.83,434.76,618.13,434.9,618.11,435Z",
    fill: "#263238",
    style: {
      transformOrigin: "617.41px 434.781px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M618.25,433.08c0,.06-.33.27-.79.49a2.11,2.11,0,0,1-.87.29c0-.06.33-.27.78-.49A2.18,2.18,0,0,1,618.25,433.08Z",
    fill: "#263238",
    style: {
      transformOrigin: "617.42px 433.47px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m618.05 431.9s-0.29 0.4-0.81 0.69a1.74 1.74 0 0 1-1 0.3 5.28 5.28 0 0 1 0.91-0.49c0.49-0.27 0.85-0.55 0.9-0.5z",
    fill: "#263238",
    style: {
      transformOrigin: "617.145px 432.392px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M616,435.08a3.24,3.24,0,0,1-1,.46,7.85,7.85,0,0,1-1.2.25,3,3,0,0,1-.74,0,.59.59,0,0,1-.4-.2.44.44,0,0,1,0-.48,2.06,2.06,0,0,1,2.57-.5,2,2,0,0,1,.64.53c.12.16.17.26.16.27a3,3,0,0,0-.87-.67,2,2,0,0,0-1.13-.17,1.75,1.75,0,0,0-1.18.64c-.11.19,0,.35.27.38a4,4,0,0,0,.69,0,7.9,7.9,0,0,0,1.18-.21C615.56,435.22,616,435.05,616,435.08Z",
    fill: "#263238",
    style: {
      transformOrigin: "614.31px 435.087px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M615.72,435.25a1.11,1.11,0,0,1-.44-.66,1.88,1.88,0,0,1-.06-.87,1.13,1.13,0,0,1,.62-.91c.25-.08.83.43.87.62s-.29.09-.31.25a3.48,3.48,0,0,1-.2.83,1.56,1.56,0,0,1-.4.68s.12-.27.26-.72a5.12,5.12,0,0,0,.15-.81c0-.28,0-.71-.32-.64s-.41.46-.48.74a1.73,1.73,0,0,0,0,.79A4.36,4.36,0,0,0,615.72,435.25Z",
    fill: "#263238",
    style: {
      transformOrigin: "615.954px 434.026px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M632.47,426.36s-.48.17-1.16.58a5.58,5.58,0,0,0-2.09,2.22,5.63,5.63,0,0,0-.57,3c.06.8.25,1.26.21,1.28a1.27,1.27,0,0,1-.15-.32,5.18,5.18,0,0,1-.21-.94,5.29,5.29,0,0,1,2.73-5.36,4.75,4.75,0,0,1,.89-.38A1.23,1.23,0,0,1,632.47,426.36Z",
    fill: "#263238",
    style: {
      transformOrigin: "630.461px 429.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m626.18 432.9a14.28 14.28 0 0 1-4.65 2.12c0-0.06 1.05-0.46 2.33-1s2.29-1.17 2.32-1.12z",
    fill: "#263238",
    style: {
      transformOrigin: "623.855px 433.959px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m629.29 431.47c0.05 0 0 0.25 0 0.54s0 0.53 0 0.55-0.2-0.22-0.2-0.55 0.15-0.57 0.2-0.54z",
    fill: "#263238",
    style: {
      transformOrigin: "629.201px 432.014px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M629.8,429.47c.05,0,0,.23-.06.47s-.21.42-.26.4,0-.23.06-.47S629.74,429.45,629.8,429.47Z",
    fill: "#263238",
    style: {
      transformOrigin: "629.64px 429.905px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M631.18,428c0,.06-.2.15-.4.34s-.31.39-.36.37,0-.3.22-.53S631.17,428,631.18,428Z",
    fill: "#263238",
    style: {
      transformOrigin: "630.791px 428.353px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M632.23,427.18s0,.16-.12.27-.23.17-.27.13,0-.16.12-.27S632.19,427.14,632.23,427.18Z",
    fill: "#263238",
    style: {
      transformOrigin: "632.027px 427.38px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M612.56,223.64l-2.92-35.7,15,.27s.69-5.27-1.52-16.81c-1.36-7.08-6.07-11.42-11.36-14v-.1l-.46-.12a42.83,42.83,0,0,0-13.76-3.59l-18.45.21S565,152,557.23,162.09c-3,3.87-12.31,30.36-12.31,30.36l22.15,10.66L565,188.42s.42,10.65,1.78,14c.75,1.88,3,7.72,3,7.72l-.29,17.62Z",
    fill: "#407bff",
    style: {
      transformOrigin: "584.831px 190.675px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "602.39 182.76 599.65 194.42 625.48 194.42 623.78 174.86",
    fill: "#407bff",
    style: {
      transformOrigin: "612.565px 184.64px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M625.48,194.42a20.7,20.7,0,0,0-3.42-.34c-2.12-.12-5-.23-8.28-.21s-6.17.16-8.29.32a19.6,19.6,0,0,0-3.41.42,21.66,21.66,0,0,0,3.44,0c2.11-.07,5-.15,8.26-.16s6.15,0,8.27.05A21.65,21.65,0,0,0,625.48,194.42Z",
    fill: "#263238",
    style: {
      transformOrigin: "613.78px 194.273px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M601.27,174.77a15.57,15.57,0,0,0-.08,3c0,1.83.08,4.35.19,7.14s.24,5.32.36,7.14a14.9,14.9,0,0,0,.32,3,15.64,15.64,0,0,0,.08-3c0-1.83-.08-4.36-.19-7.15s-.24-5.31-.36-7.14A14.71,14.71,0,0,0,601.27,174.77Z",
    fill: "#263238",
    style: {
      transformOrigin: "601.665px 184.91px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "593.51px 205.601px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M577.77,184.87s5.74,42.57,21.88,41.44c0,0,7.27-.08,9.6-4.91v-1.9Z",
    style: {
      transformOrigin: "593.51px 205.601px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "600.83px 189.545px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "601.27 177.28 598.18 198.15 600.18 201.81 603.48 194.65 602.08 194.61",
    style: {
      transformOrigin: "600.83px 189.545px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M569.69,210.16a4,4,0,0,1-.44-1c-.25-.65-.58-1.6-1-2.79a86.11,86.11,0,0,1-2.47-9.45,67,67,0,0,1-1.22-9.69c-.06-1.25-.08-2.26-.06-3a4,4,0,0,1,.07-1.08c.08,0,.14,1.54.35,4a89,89,0,0,0,1.37,9.61c.74,3.72,1.63,7.05,2.31,9.44.32,1.11.59,2.06.81,2.84A4.89,4.89,0,0,1,569.69,210.16Z",
    fill: "#263238",
    style: {
      transformOrigin: "567.09px 196.655px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M576.21,222.39c-.14,0-.54-.87-.89-2a4.8,4.8,0,0,1-.39-2.2,5.22,5.22,0,0,1,.89,2.05A5,5,0,0,1,576.21,222.39Z",
    fill: "#263238",
    style: {
      transformOrigin: "575.568px 220.29px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m578.44 222.23a9.2 9.2 0 0 1-0.09-6.24 20.81 20.81 0 0 1 0 3.12 20.56 20.56 0 0 1 0.09 3.12z",
    fill: "#263238",
    style: {
      transformOrigin: "578.156px 219.11px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m567.52 203.6c-0.07 0.12-5.22-2.32-11.51-5.46s-11.34-5.8-11.28-5.93 5.22 2.32 11.51 5.46 11.34 5.8 11.28 5.93z",
    fill: "#263238",
    style: {
      transformOrigin: "556.125px 197.905px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m576.6 157.25c0.11-5.06 0.14-10.38 0.14-10.38s-6.49-1.25-7.62-9.79c-1.08-8.14 1.94-27.25 1.94-27.25 9.48-3.58 19.33-0.33 25.82 7.35l-1.61 41.07c-0.19 4.77-4.44 8.41-9.54 8.17-5.16-0.25-9.24-4.35-9.13-9.17z",
    fill: "#b78876",
    style: {
      transformOrigin: "582.883px 137.404px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m570.56 125.1a1.1 1.1 0 0 0 1 1.13 1.05 1.05 0 0 0 1.15-1 1.09 1.09 0 0 0-1-1.12 1 1 0 0 0-1.15 0.99z",
    fill: "#263238",
    style: {
      transformOrigin: "571.635px 125.167px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M570.16,123.67c.13.14,1-.45,2.15-.41s2,.64,2.14.5-.06-.32-.43-.61a3,3,0,0,0-1.72-.57,2.81,2.81,0,0,0-1.71.5C570.22,123.35,570.09,123.6,570.16,123.67Z",
    fill: "#263238",
    style: {
      transformOrigin: "572.318px 123.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m582.47 125.84a1.09 1.09 0 0 0 1 1.13 1 1 0 0 0 1.15-1 1.08 1.08 0 0 0-1-1.12 1 1 0 0 0-1.15 0.99z",
    fill: "#263238",
    style: {
      transformOrigin: "583.545px 125.91px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M582.39,124.41c.13.15,1-.44,2.15-.41s2,.64,2.15.5-.07-.32-.44-.6a2.87,2.87,0,0,0-1.71-.58,2.91,2.91,0,0,0-1.72.5C582.46,124.09,582.33,124.34,582.39,124.41Z",
    fill: "#263238",
    style: {
      transformOrigin: "584.557px 123.92px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M577.91,133a7.56,7.56,0,0,0-1.9-.39c-.3,0-.58-.11-.62-.31a1.46,1.46,0,0,1,.22-.89l.94-2.25a39.1,39.1,0,0,0,2.15-5.92,39.62,39.62,0,0,0-2.62,5.73c-.31.79-.62,1.55-.91,2.27a1.75,1.75,0,0,0-.18,1.17.75.75,0,0,0,.48.46,2.05,2.05,0,0,0,.51.08A7.63,7.63,0,0,0,577.91,133Z",
    fill: "#263238",
    style: {
      transformOrigin: "576.829px 128.139px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m576.74 146.87a21.66 21.66 0 0 0 11.46-2.75s-2.91 5.77-11.4 4.76z",
    fill: "#a36957",
    style: {
      transformOrigin: "582.47px 146.559px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M586.15,121c-.24.37-1.14.21-2.14,0s-1.88-.38-2-.81.93-1,2.27-.73S586.39,120.68,586.15,121Z",
    fill: "#263238",
    style: {
      transformOrigin: "584.097px 120.306px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M574.48,119.3c-.09.43-1.05.59-2.15.64s-2.07,0-2.2-.44.8-1.06,2.13-1.12S574.57,118.89,574.48,119.3Z",
    fill: "#263238",
    style: {
      transformOrigin: "572.302px 119.166px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M577.93,135.81a.58.58,0,0,0-.65.3.67.67,0,1,0,1.17,0,.67.67,0,0,0-.77-.33",
    fill: "#a36957",
    style: {
      transformOrigin: "577.865px 136.431px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M578.2,135.93c0-.05-.19-.34-.7-.23a.9.9,0,0,0-.64.63,1,1,0,0,0,.35,1.06,1,1,0,0,0,1.13,0,.84.84,0,0,0,.36-.83c-.1-.53-.49-.61-.51-.54s.14.25.11.56a.47.47,0,0,1-.24.37.51.51,0,0,1-.51,0,.53.53,0,0,1-.18-.49.49.49,0,0,1,.27-.37C577.92,135.92,578.17,136,578.2,135.93Z",
    fill: "#263238",
    style: {
      transformOrigin: "577.767px 136.62px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M593,127.21c-1,2.34-3.48,4.15-3.14,6.68.22,1.63,1.27,3.15,1.07,4.79-.26,2-2.39,3.48-2.7,5.53-.37,2.51,2.08,4.46,3.05,6.8,1.43,3.42-.39,7.26-.44,11a11.74,11.74,0,0,0,10.4,11.42c2.28.19,4.85-.5,6-2.46,1-1.62.78-3.68,1.36-5.47.88-2.68,3.43-4.64,4-7.4,1-5-5.1-9.2-4.7-14.32.17-2.19,1.52-4.09,2.09-6.21a9.12,9.12,0,0,0-1.78-8.09c-1.51-1.79-3.69-3-5-4.92-1.45-2.21-1.5-5-2-7.61a19.18,19.18,0,0,0-30.46-11.23s-1.45,6.59,5.32,7.7,9.9-.17,10.66,2.54a7.16,7.16,0,0,0,2,6.19C591.49,125.13,594.12,124.49,593,127.21Z",
    fill: "#263238",
    style: {
      transformOrigin: "591.665px 137.601px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M603.75,172.92a2.39,2.39,0,0,1-.62-.06,9.78,9.78,0,0,1-1.72-.47,12.21,12.21,0,0,1-5.24-3.87,13.86,13.86,0,0,1-2.22-4,15.85,15.85,0,0,1-.91-5.13,21.19,21.19,0,0,1,.72-5.71,24.45,24.45,0,0,1,1-2.89,29.55,29.55,0,0,0,1.09-2.87,5.34,5.34,0,0,0,0-2.94,16.3,16.3,0,0,0-1.13-2.74,18,18,0,0,1-1.17-2.71,5.85,5.85,0,0,1-.21-2.87c.4-1.88,1.54-3.28,2.22-4.71a8.91,8.91,0,0,0,.9-4.26,10.05,10.05,0,0,0-2.23-5.9,17.59,17.59,0,0,0-1.69-1.65,6.84,6.84,0,0,1,1.85,1.52,10,10,0,0,1,2.44,6,9.24,9.24,0,0,1-.88,4.46c-.69,1.48-1.8,2.89-2.14,4.61s.47,3.53,1.36,5.27a15.58,15.58,0,0,1,1.18,2.83,5.89,5.89,0,0,1,0,3.2A31.35,31.35,0,0,1,595.2,151a23.52,23.52,0,0,0-1,2.83,20.61,20.61,0,0,0-.73,5.57,14.46,14.46,0,0,0,2.94,8.88,12.28,12.28,0,0,0,5,3.91C602.9,172.77,603.76,172.86,603.75,172.92Z",
    fill: "#455a64",
    style: {
      transformOrigin: "598.145px 146.531px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M602.75,122.46a7.07,7.07,0,0,1-1.49.22,15.51,15.51,0,0,1-4.12-.11,7.85,7.85,0,0,1-5.2-3.15,17,17,0,0,1-1.36-3.36,5.58,5.58,0,0,0-2.28-2.81c-2.19-1.39-4.76-1.56-7-1.83a12.21,12.21,0,0,1-5.83-1.82,5.77,5.77,0,0,1-2.39-3.33,3.35,3.35,0,0,1-.07-1.13c0-.26.06-.39.08-.39a7.08,7.08,0,0,0,.19,1.47,5.72,5.72,0,0,0,2.4,3.08,12.09,12.09,0,0,0,5.67,1.64c2.24.26,4.9.39,7.24,1.87a6.08,6.08,0,0,1,2.48,3.07,16.73,16.73,0,0,0,1.29,3.28,7.55,7.55,0,0,0,4.86,3,17.26,17.26,0,0,0,4,.27A10.11,10.11,0,0,1,602.75,122.46Z",
    fill: "#455a64",
    style: {
      transformOrigin: "587.87px 113.759px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M600.27,114.32a3.33,3.33,0,0,1-1.17.17,7.13,7.13,0,0,1-5-2,9.18,9.18,0,0,1-1.55-2.07c-.9-1.52-1.77-3.39-3.64-4.17a12,12,0,0,0-5.6-.49,17.18,17.18,0,0,1-4.78,0,6,6,0,0,1-3-1.32,3.32,3.32,0,0,1-.58-.66q-.18-.26-.15-.27s.28.32.86.77a6.3,6.3,0,0,0,2.89,1.12,18.14,18.14,0,0,0,4.68-.08,12,12,0,0,1,5.85.5,5.75,5.75,0,0,1,2.39,2,25.76,25.76,0,0,1,1.45,2.42,9.52,9.52,0,0,0,1.45,2,7,7,0,0,0,1.71,1.27,7.42,7.42,0,0,0,3,.83C599.85,114.33,600.26,114.27,600.27,114.32Z",
    fill: "#455a64",
    style: {
      transformOrigin: "587.533px 109.001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M606.73,170.76c-.05,0,.27-.66.64-1.9a17.2,17.2,0,0,0,.66-5.36,16.32,16.32,0,0,0-2.13-7.63c-.73-1.31-1.84-2.48-2.75-3.92a7,7,0,0,1-1-2.41,5.39,5.39,0,0,1,.22-2.7c.56-1.73,1.56-3.18,1.78-4.77s-.54-3-1.3-4.33a21.3,21.3,0,0,1-1.07-2,7.32,7.32,0,0,1-.57-2.09,18.12,18.12,0,0,1,.12-3.81,10.11,10.11,0,0,0-.48-5.32,4.84,4.84,0,0,0-1.18-1.56s.05,0,.12.06a1.22,1.22,0,0,1,.32.23,3.57,3.57,0,0,1,.93,1.19,9.88,9.88,0,0,1,.65,5.43,19.17,19.17,0,0,0-.05,3.73,9.6,9.6,0,0,0,1.62,3.88,13.3,13.3,0,0,1,1.09,2.13,5,5,0,0,1,.3,2.52c-.24,1.75-1.27,3.23-1.79,4.86a5,5,0,0,0-.21,2.45,6.66,6.66,0,0,0,.94,2.23c.85,1.39,2,2.58,2.73,3.95a16.5,16.5,0,0,1,2.08,7.87,16.18,16.18,0,0,1-.84,5.43,10.43,10.43,0,0,1-.58,1.38A1.84,1.84,0,0,1,606.73,170.76Z",
    fill: "#455a64",
    style: {
      transformOrigin: "604.036px 146.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M566,357.09s-6.74-63.84-7.13-87.43,10.61-46.87,10.61-46.87L612.56,221s8.52,23.93,8.67,34c.3,19.54-5.19,38.83-4.56,54.33l1.44,47.8",
    fill: "#263238",
    style: {
      transformOrigin: "590.051px 289.065px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M619.56,278.6a6.88,6.88,0,0,1-.71.54l-.39.27-.42.41a6.92,6.92,0,0,0-1,1.07c-1.39,1.7-2.4,4.75-3.37,8.54a28.7,28.7,0,0,1-2.18,6.08,10.64,10.64,0,0,1-1,1.51c-.18.24-.35.5-.56.73l-.66.66a10.71,10.71,0,0,1-3.24,2.08c-2.41,1.06-5.14,1.56-7.62,2.81a12,12,0,0,0-5.53,6.3c-1.22,2.71-2,5.55-3,8.21s-2.35,5.2-4.5,6.82a12.36,12.36,0,0,1-7,2.21c-2.32.14-4.47.07-6.4.36a10.11,10.11,0,0,0-4.82,1.82,6.76,6.76,0,0,0-2.24,3.16,4.8,4.8,0,0,0-.17,2.45c.12.56.27.83.24.84a2.52,2.52,0,0,1-.34-.82,4.59,4.59,0,0,1,.08-2.53,6.8,6.8,0,0,1,2.25-3.33,10.25,10.25,0,0,1,5-2c2-.32,4.13-.28,6.42-.43a12,12,0,0,0,6.79-2.16,14.52,14.52,0,0,0,4.31-6.62c1-2.63,1.73-5.48,3-8.24a12.5,12.5,0,0,1,5.78-6.55c2.58-1.28,5.31-1.77,7.66-2.79a10.49,10.49,0,0,0,3.12-2l.63-.63c.2-.22.37-.47.55-.7a9.65,9.65,0,0,0,.93-1.45,28.68,28.68,0,0,0,2.21-6c1-3.78,2.09-6.87,3.56-8.58a6.51,6.51,0,0,1,1-1.06c.16-.14.3-.28.44-.39l.41-.26A6.93,6.93,0,0,1,619.56,278.6Z",
    fill: "#fafafa",
    style: {
      transformOrigin: "592.035px 307.035px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M619.82,249.06a4.67,4.67,0,0,1,.06.85,10.48,10.48,0,0,1-.3,2.45,15.75,15.75,0,0,1-4.87,7.52,28.93,28.93,0,0,1-5,3.69c-1.93,1.14-4.06,2.23-6.25,3.47a32.29,32.29,0,0,0-6.38,4.49,24.64,24.64,0,0,0-4.84,6.79,62.1,62.1,0,0,1-4.19,7.39,17.66,17.66,0,0,1-2.74,3A16.54,16.54,0,0,1,582,290.9a39.9,39.9,0,0,1-6.69,2.57c-2.14.66-4.14,1.25-5.88,2a22.51,22.51,0,0,0-4.48,2.4,13.87,13.87,0,0,0-2.81,2.59,12.85,12.85,0,0,0-1.69,2.8,5.28,5.28,0,0,1,.28-.81,10,10,0,0,1,1.25-2.12,13.47,13.47,0,0,1,2.8-2.7,22.83,22.83,0,0,1,4.51-2.5,60,60,0,0,1,5.89-2.05,41.38,41.38,0,0,0,6.6-2.58,17.05,17.05,0,0,0,3.15-2.12,17.74,17.74,0,0,0,2.64-2.94,64.33,64.33,0,0,0,4.15-7.34,24.83,24.83,0,0,1,5-6.92,32.23,32.23,0,0,1,6.5-4.54c2.2-1.23,4.33-2.3,6.26-3.43a28.87,28.87,0,0,0,5-3.58,15.86,15.86,0,0,0,4.92-7.31A15.29,15.29,0,0,0,619.82,249.06Z",
    fill: "#fafafa",
    style: {
      transformOrigin: "590.166px 276.16px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M559.09,273a.75.75,0,0,1-.09-.2,5.22,5.22,0,0,1-.19-.59,4.78,4.78,0,0,1,.1-2.4c.56-2,2.77-4.57,6.33-5.84,1.78-.61,3.79-1,5.89-1.52a11.09,11.09,0,0,0,8.15-6.07,32.14,32.14,0,0,0,1.49-3.59,39.13,39.13,0,0,1,3.17-7.67,12.22,12.22,0,0,1,6.52-5.07,59.22,59.22,0,0,1,7.49-1.9,24.83,24.83,0,0,0,6.51-2.22,13.7,13.7,0,0,0,4.4-4,14.88,14.88,0,0,0,2.8-8.1,23,23,0,0,0-.21-3.2,10.41,10.41,0,0,1,.41,3.2,14.73,14.73,0,0,1-2.7,8.31,13.84,13.84,0,0,1-4.49,4.13,24.93,24.93,0,0,1-6.61,2.31,59.58,59.58,0,0,0-7.42,1.91,11.74,11.74,0,0,0-6.26,4.87,39.19,39.19,0,0,0-3.13,7.56,31.15,31.15,0,0,1-1.53,3.65,13.21,13.21,0,0,1-2.24,3.1,13,13,0,0,1-6.25,3.15c-2.12.54-4.12.88-5.87,1.46-3.47,1.18-5.67,3.61-6.26,5.55a5.07,5.07,0,0,0-.19,2.32A5,5,0,0,1,559.09,273Z",
    fill: "#fafafa",
    style: {
      transformOrigin: "585.283px 246.815px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M616.12,327a3.82,3.82,0,0,1,.07.63,6.64,6.64,0,0,1-.19,1.8,10.21,10.21,0,0,1-3.78,5.4,16.67,16.67,0,0,1-4,2.36c-1.53.65-3.22,1.17-5,1.72a41.32,41.32,0,0,0-5.41,2A15.45,15.45,0,0,0,593,344.5c-1.46,1.52-2.72,3.19-4.12,4.67a18.77,18.77,0,0,1-4.61,3.6,20.31,20.31,0,0,1-9.51,2.48,18.94,18.94,0,0,1-6.54-1.09,12.48,12.48,0,0,1-1.66-.71,2.63,2.63,0,0,1-.55-.31,4.25,4.25,0,0,1,.59.21,17.72,17.72,0,0,0,1.68.62,20,20,0,0,0,6.48.91,20.21,20.21,0,0,0,9.28-2.53,18.68,18.68,0,0,0,4.47-3.53c1.37-1.46,2.62-3.12,4.11-4.68a16.06,16.06,0,0,1,5.08-3.7,41.39,41.39,0,0,1,5.49-2c1.76-.54,3.44-1,5-1.66a16.77,16.77,0,0,0,3.9-2.25,10.2,10.2,0,0,0,3.81-5.16A12.69,12.69,0,0,0,616.12,327Z",
    fill: "#fafafa",
    style: {
      transformOrigin: "591.102px 341.126px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M611.21,194.46l-8.34.2a13.49,13.49,0,0,1-1.88,4.73c-7-12.1-12.37-28.3-13.71-34.81.2-.65.43-1.37.72-2.17a9.24,9.24,0,0,0-.11-3.66c-.24-1.45-.64-3.4-.76-4.3-.37-2.76-.82-3.19-1.78-2.88-1.3.43.54,7.73-.53,7.89-.58.08-1.28-2.42-1.48-4.47s-1.14-8.37-1.81-8.79c-1-.62-1.87.36-1.61,2.4s.57,8.24-.51,8.33-2-10.39-2-10.39.17-2.28-1.09-2.23c-2.26.1-.49,11.14-.3,12.19.14.72-1,.86-1.14.07s-.66-10.47-3-10.39c-1.78,0,1.37,9.09.37,11.19s-1.68-7.12-3.37-7c-.63.05-1.1.17.06,5.38a118.2,118.2,0,0,0,4,12.21c2.68,14.45,14.44,60.68,32.87,52.22,10.32-4.74,14.5-25.72,14.5-25.72Z",
    fill: "#b78876",
    style: {
      transformOrigin: "594.27px 182.757px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M575.66,157.2a.49.49,0,0,0,.24,0,.53.53,0,0,0,.37-.58c0-.62-.12-1.52-.26-2.69a37.55,37.55,0,0,1-.46-4.26c0-.84,0-1.74.05-2.69a9.9,9.9,0,0,1,.15-1.44c.08-.45.38-1,.73-.91h.06c.35,0,.63.26.74.68a3.92,3.92,0,0,1,.14,1.34v0h0a78,78,0,0,0,1.07,8.35c.08.37.16.75.28,1.13a4.3,4.3,0,0,0,.2.57,3.18,3.18,0,0,0,.17.3.55.55,0,0,0,.42.26.74.74,0,0,0,.63-.53,2.86,2.86,0,0,0,.19-.61,10.19,10.19,0,0,0,.16-1.22,36.44,36.44,0,0,0-.07-5,11.3,11.3,0,0,1-.1-2.51,1.4,1.4,0,0,1,.49-.93.53.53,0,0,1,.43-.05.82.82,0,0,1,.24.1.32.32,0,0,1,.11.15,12.75,12.75,0,0,1,.69,2.51c.18.88.33,1.79.47,2.7s.27,1.83.38,2.76a20.36,20.36,0,0,0,.46,2.85,11,11,0,0,0,.45,1.41,2.65,2.65,0,0,0,.42.71.59.59,0,0,0,.59.22.62.62,0,0,0,.41-.45,5,5,0,0,0,.11-1.56c0-.5-.06-1-.11-1.48-.07-.84-.15-1.67-.18-2.49a9.68,9.68,0,0,1,0-1.21,2,2,0,0,1,.13-.52.49.49,0,0,1,.09-.15l0,0,.13,0c.66-.27.88.65,1.06,1.39s.25,1.58.41,2.37c.26,1.57.6,3.14.77,4.64a5.53,5.53,0,0,1-.08,2.16c-.24.72-.48,1.43-.71,2.14l0,.07,0,.06a115.17,115.17,0,0,0,4.47,14.46c1.58,4.27,3.17,8,4.56,11s2.65,5.35,3.51,6.93l1,1.79a3.36,3.36,0,0,0,.39.6,4,4,0,0,0-.31-.64l-1-1.83c-.82-1.61-2-4-3.36-7s-2.9-6.73-4.44-11a119.4,119.4,0,0,1-4.38-14.42v.14c.23-.7.46-1.41.7-2.12a5.72,5.72,0,0,0,.12-2.39c-.18-1.57-.51-3.09-.77-4.67-.15-.78-.25-1.58-.41-2.4A4.4,4.4,0,0,0,587,152a1.18,1.18,0,0,0-.55-.56,1.27,1.27,0,0,0-.79,0l-.16,0a.65.65,0,0,0-.23.13.88.88,0,0,0-.25.35,2.26,2.26,0,0,0-.17.68,9.46,9.46,0,0,0,0,1.3c0,.84.12,1.68.19,2.52,0,.49.08,1,.1,1.45a4.86,4.86,0,0,1-.07,1.35c0,.1-.08.08,0,.13h0s0,0,0,0h0s0,0,0,0,0,0,0,0l-.06-.06a2,2,0,0,1-.3-.54,9.83,9.83,0,0,1-.43-1.33,18.59,18.59,0,0,1-.45-2.77q-.16-1.41-.39-2.79c-.14-.92-.3-1.82-.48-2.72a12.18,12.18,0,0,0-.76-2.67.85.85,0,0,0-.31-.35,1.73,1.73,0,0,0-.37-.16,1.11,1.11,0,0,0-.85.12,1.87,1.87,0,0,0-.74,1.3,4.85,4.85,0,0,0,0,1.37c0,.43.1.85.13,1.27a37,37,0,0,1,.09,4.92,8.54,8.54,0,0,1-.15,1.16,2.23,2.23,0,0,1-.15.52.61.61,0,0,1-.11.18c0,.09-.07,0-.06.12,0-.1,0,0,0-.13a2,2,0,0,1-.12-.21c-.07-.16-.13-.34-.19-.51-.11-.36-.19-.73-.27-1.09a79.46,79.46,0,0,1-1.13-8.28v0a4.35,4.35,0,0,0-.17-1.49,1.4,1.4,0,0,0-.39-.66,1,1,0,0,0-.74-.28h.06a.87.87,0,0,0-.87.41,2.21,2.21,0,0,0-.3.78,10.09,10.09,0,0,0-.14,1.5c0,1,0,1.87,0,2.72a34.89,34.89,0,0,0,.55,4.28c.17,1.16.3,2.06.36,2.67a.47.47,0,0,1-.29.52C575.74,157.18,575.65,157.19,575.66,157.2Z",
    fill: "#a36957",
    style: {
      transformOrigin: "588.24px 171.915px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M510.53,208.23a21.41,21.41,0,0,0-5.79.67c-5.17,1.36-14.08,6.76-14.45,13.43h6.48s-3.63,7.72-2.57,7c2.77-1.86,8.27-7.45,8.27-7.45Z",
    fill: "#b78876",
    style: {
      transformOrigin: "500.41px 218.801px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M598.86,92c-.15,0-.73-5.34-1.31-12s-.94-12-.8-12,.73,5.34,1.31,12S599,92,598.86,92Z",
    fill: "#263238",
    style: {
      transformOrigin: "597.805px 80px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m627.27 68.41c0.11 0.08-4.26 6.43-9.77 14.18s-10.08 14-10.2 13.88 4.26-6.43 9.77-14.18 10.08-13.96 10.2-13.88z",
    fill: "#263238",
    style: {
      transformOrigin: "617.285px 82.4405px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m639.07 97.19c0 0.14-5.08 1.31-11.4 2.61s-11.48 2.24-11.51 2.1 5.07-1.31 11.4-2.61 11.44-2.24 11.51-2.1z",
    fill: "#263238",
    style: {
      transformOrigin: "627.615px 99.545px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "366.753px 314.59px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m299 234.54-35.4 181.8-4.6 23.8 236-1.14c10.6-0.05 20-9.46 23.39-23.44l41.86-171.63c2.59-10.61-3.09-21.65-11.13-21.64l-238.92 0.25c-5.2-0.01-9.86 4.91-11.2 12z",
    fill: "#407bff",
    style: {
      transformOrigin: "409.942px 331.215px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.5,
    style: {
      transformOrigin: "409.942px 331.215px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m299 234.54-35.4 181.8-4.6 23.8 236-1.14c10.6-0.05 20-9.46 23.39-23.44l41.86-171.63c2.59-10.61-3.09-21.65-11.13-21.64l-238.92 0.25c-5.2-0.01-9.86 4.91-11.2 12z",
    style: {
      transformOrigin: "409.942px 331.215px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M472.39,404l-25-201.41c-1-8.25-7.59-14.41-15.36-14.38l-54.8.17a15,15,0,0,0-10.83,4.8l-26,27.67L188,221.67c-9.31.05-16.47,8.87-15.24,18.77l23.21,186.15c1,8.24,7.59,14.39,15.34,14.38l265.65-.53c29.58.61,32.41-8.12,32.41-8.12C475.41,439.83,472.39,404.05,472.39,404Z",
    fill: "#407bff",
    style: {
      transformOrigin: "340.996px 314.59px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    fill: "#fff",
    opacity: 0.5,
    style: {
      transformOrigin: "318.86px 337.49px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "357.84 363.72 348.88 373.34 279.88 311.26 288.84 301.64",
    style: {
      transformOrigin: "318.86px 337.49px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "345.13 299.51 355.03 308.42 292.6 375.47 282.69 366.56",
    style: {
      transformOrigin: "318.86px 337.49px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "514.235px 92.0246px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M510.32,103.78a1.85,1.85,0,0,1-1.13-1.63l-.4-9.28a1.86,1.86,0,0,1,2.29-1.9,5.82,5.82,0,0,0,4.52-.89,5.21,5.21,0,0,0,2.33-3.42,5.33,5.33,0,0,0-1.12-4,6,6,0,0,0-3.94-2.37,7,7,0,0,0-7.1,5,1.87,1.87,0,0,1-3.6-1,10.76,10.76,0,0,1,11.13-7.77,9.66,9.66,0,0,1,6.49,3.83,9.13,9.13,0,0,1,1.83,6.87,9,9,0,0,1-4,5.92,9.72,9.72,0,0,1-5.06,1.65l.31,7.16a1.87,1.87,0,0,1-2.6,1.79Z",
    fill: "#407bff",
    style: {
      transformOrigin: "511.916px 90.1901px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m513.06 107.58a1.53 1.53 0 1 1-1.63-1.42 1.52 1.52 0 0 1 1.63 1.42z",
    fill: "#407bff",
    style: {
      transformOrigin: "511.534px 107.686px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M478.19,90.69a4.68,4.68,0,0,0,.09-.6c0-.44.11-1,.19-1.79a21.67,21.67,0,0,1,.49-2.88c.13-.56.2-1.18.4-1.81s.4-1.31.62-2a34.49,34.49,0,0,1,5-9.53,33.5,33.5,0,0,1,10.51-9.14,33,33,0,0,1,7.41-3.06,33.55,33.55,0,0,1,8.55-1.12A33.16,33.16,0,0,1,516,59c.77.08,1.53.28,2.3.41a17.12,17.12,0,0,1,2.3.56A32,32,0,0,1,529.49,64a33.44,33.44,0,0,1,13.22,16.6,32.74,32.74,0,0,1,2,11.41,32.16,32.16,0,0,1-2.09,11.74l-.45,1.14-.06.15.06.15c2.51,5.77,5,11.44,7.35,16.93l.42-.48-15-5.75-.18-.07-.15.14a33.49,33.49,0,0,1-14.14,8.16,33.31,33.31,0,0,1-27-4.19,34.17,34.17,0,0,1-8.43-7.85,33.21,33.21,0,0,1-6.4-15.34c-.12-1-.22-1.84-.31-2.6s0-1.38-.05-1.91,0-.88,0-1.17a.2.2,0,1,0-.06,0c0,.29,0,.68,0,1.17s0,1.17,0,1.93.17,1.63.27,2.62a35.77,35.77,0,0,0,1.71,7.06,36.61,36.61,0,0,0,4.58,8.5,34.47,34.47,0,0,0,8.49,8,33.75,33.75,0,0,0,27.41,4.38A34,34,0,0,0,535,116.48l-.33.07,15,5.78.75.29-.33-.77c-2.38-5.49-4.84-11.15-7.34-16.93v.29l.46-1.17a32.7,32.7,0,0,0,2.14-12,33.45,33.45,0,0,0-2-11.66,34,34,0,0,0-13.51-16.91,32.3,32.3,0,0,0-9.12-4.1,15.89,15.89,0,0,0-2.34-.55c-.78-.14-1.55-.34-2.33-.41a34.39,34.39,0,0,0-4.61-.26,33.56,33.56,0,0,0-8.68,1.18,34.19,34.19,0,0,0-7.51,3.14,33.57,33.57,0,0,0-10.57,9.35,34.2,34.2,0,0,0-4.93,9.68c-.21.72-.41,1.41-.59,2a17.6,17.6,0,0,0-.38,1.83,19,19,0,0,0-.42,2.9c-.06.77-.1,1.36-.13,1.8A2.54,2.54,0,0,0,478.19,90.69Z",
    fill: "#263238",
    style: {
      transformOrigin: "514.235px 92.0246px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoasset);
export default __webpack_public_path__ + "static/media/noasset.7708c169381ccd9cd675e8493c4fc863.svg";
export { ForwardRef as ReactComponent };